import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ClipboardService } from 'ngx-clipboard';
import { SupervisionOperationService } from '../../data-access/supervision-operation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TraitementShowComponent } from '../../../../../shared/components/traitement-show/traitement-show.component';
import { OperationTransaction } from 'src/shared/enum/OperationTransaction.enum';
import { StatutTransaction } from './../../../../../shared/enum/StatutTransaction.enum';
import { MappingService } from 'src/shared/services/mapping.service';
import { SettingService } from 'src/shared/services/setting.service';
import * as moment from 'moment';
import { ExcelService } from 'src/shared/services/excel.service';
import { Title } from '@angular/platform-browser';
import { ModalParams } from 'src/shared/constants/modalParams.contant';
import { TraitementTransaction } from '../../../../../shared/enum/TraitementTransaction.enum';
import { TitleOperation } from '../../../../../shared/enum/OperationTransaction.enum';
const Swal = require('sweetalert2');

@Component({
    selector: 'app-contentieux',
    templateUrl: './contentieux.component.html',
    styleUrls: ['./contentieux.component.scss'],
})
export class ContentieuxComponent implements OnInit {
    public listTraitemants: Array<any> = [];
    public listOperations: Array<any> = [];
    public listStatutTransactions: Array<any> = [];
    public listTraitementTransactions: Array<any> = [];
    public listUsers: Array<any> = [];
    public totalPage: 0;
    public totalRecords: 0;
    public recordsPerPage: 0;
    public offset: any;
    public p: number = 1;
    public page: number = 0;
    public selectedTypeOperation: any;
    public selectedTransaction: any;
    public selectedStatut: any;
    public selectedTraitement: any;
    public secondFilter: boolean = false;
    public firstLevelLibelle: string;
    public secondLevelLibelle: string;
    public thirdLevelLibelle: string;
    public filterDateStart: Date;
    public filterDateEnd: Date;
    public currentUser: any;
    public selectDateStart: any;
    public selectDateEnd: any;
    public IsLoading: boolean;
    public stateSoumis: string = StatutTransaction.SOUMIS;
    public stateTraite: string = StatutTransaction.TARITER;
    public stateCloture: string = StatutTransaction.CLOTURER;
    public treatmenEntente: string = TraitementTransaction.EN_ENTENTE;
    public treatmenAcquiter: string = TraitementTransaction.ACQUITER;
    public treatmenAccepter: string = TraitementTransaction.ACCEPTER;
    public treatmenRejeter: string = TraitementTransaction.REJETER;
    public treatmenCancel: string = TraitementTransaction.ABANDONNER;
    public treatmenRefuser: string = TraitementTransaction.REFUSER;
    public title =
        'Supervision contentieux - Système de Gestion de Collecte Centralisée';

    constructor(
        private supervisionOperationService: SupervisionOperationService,
        private toastrService: ToastrService,
        private clipboardApi: ClipboardService,
        private modalService: NgbModal,
        private settingService: SettingService,
        private mappingService: MappingService,
        private excelService: ExcelService,
        private titleService: Title
    ) {
        this.titleService.setTitle(`${this.title}`);
        this.listOperations = this.mappingService.listOperationTraitementVue;
        Object.values(StatutTransaction).forEach((item) => {
            this.listStatutTransactions.push(item);
        });
        Object.values(TraitementTransaction).forEach((item) => {
            this.listTraitementTransactions.push(item);
        });
        this.firstLevelLibelle = this.mappingService.structureGlobale?.niveau_1;
        this.secondLevelLibelle =
            this.mappingService.structureGlobale?.niveau_2;
        this.thirdLevelLibelle = this.mappingService.structureGlobale?.niveau_3;
    }

    ngOnInit() {
        this.isFilter();
        this.GetAllContencieux();
        this.getAllUsers();
    }
    public GetAllContencieux() {
        this.supervisionOperationService.GetAllContencieux({}).subscribe({
            next: (response) => {
                this.listTraitemants = response['data']['data'].map((data) => {
                    if (data?.statut === StatutTransaction.TARITER) {
                        return { ...data, current_date: data?.date_traitement };
                    } else if (data?.statut === StatutTransaction.CLOTURER) {
                        return { ...data, current_date: data?.date_cloture };
                    } else if (
                        data?.statut === StatutTransaction.SOUMIS &&
                        data?.traitement === TraitementTransaction.ACQUITER
                    ) {
                        return {
                            ...data,
                            current_date: data?.date_acquittement,
                        };
                    } else {
                        return { ...data, current_date: 'N/A' };
                    }
                });
                this.totalPage = response.data.last_page;
                this.totalRecords = response.data.total;
                this.recordsPerPage = response.data.per_page;
                this.page = response.data?.current_page;
                this.offset =
                    (response.data.current_page - 1) * this.recordsPerPage + 1;
            },
            error: (error) => {
                this.toastrService.error(error.error.message);
            },
        });
    }

    public onFilter(): void {
        if (moment(this.selectDateStart).isAfter(moment(this.selectDateEnd))) {
            this.toastrService.error('Plage de date invalide');
            return;
        }
        const data = {
            operation: this.selectedTypeOperation,
            transaction: this.selectedTransaction,
            initie_par: this.currentUser?.id,
            date_debut: this.selectDateStart,
            date_fin: this.selectDateEnd,
        };
        this.supervisionOperationService.GetAllContencieux(data).subscribe({
            next: (response) => {
                this.listTraitemants = response['data']['data'].map((data) => {
                    if (data?.statut === StatutTransaction.TARITER) {
                        return { ...data, current_date: data?.date_traitement };
                    } else if (data?.statut === StatutTransaction.CLOTURER) {
                        return { ...data, current_date: data?.date_cloture };
                    } else if (
                        data?.statut === StatutTransaction.SOUMIS &&
                        data?.traitement === TraitementTransaction.ACQUITER
                    ) {
                        return {
                            ...data,
                            current_date: data?.date_acquittement,
                        };
                    } else {
                        return { ...data, current_date: 'N/A' };
                    }
                });
                this.totalPage = response['data'].last_page;
                this.totalRecords = response['data'].total;
                this.recordsPerPage = response['data'].per_page;
                this.page = response.data?.current_page;
                this.offset =
                    (response['data'].current_page - 1) * this.recordsPerPage +
                    1;
                // this.listTraitemants.length === 0 ?
                //   Swal.fire('PATRIMOINE SIM', 'Aucune donnée pour cet Tenant', 'error')
                //   : ''
            },
            error: (error) => {
                this.toastrService.error(error.error.message);
            },
        });
    }
    public onPageChange(event) {
        this.p = event;
        if (this.isFilter()) {
            this.GetAllContencieux();
        } else {
            this.onFilter();
        }
    }
    OnRefresh() {
        this.p = 1;
        this.GetAllContencieux();
        this.selectedTypeOperation = null;
        this.selectedTransaction = null;
        this.selectedStatut = null;
        this.selectedTraitement = null;
        this.currentUser = null;
        this.selectDateStart = null;
        this.selectDateEnd = null;
        this.filterDateStart = null;
        this.filterDateEnd = null;
    }
    public OnChangeStatut(event) {
        const currentStatut = event.value;
        if (currentStatut === StatutTransaction.SOUMIS) {
            this.listTraitementTransactions.splice(
                0,
                this.listTraitementTransactions.length
            );
            this.listTraitementTransactions = [
                TraitementTransaction.EN_ENTENTE,
                TraitementTransaction.ACQUITER,
            ];
        } else if (currentStatut === StatutTransaction.TARITER) {
            this.listTraitementTransactions.splice(
                0,
                this.listTraitementTransactions.length
            );
            this.listTraitementTransactions = [
                TraitementTransaction.ACCEPTER,
                TraitementTransaction.REJETER,
            ];
        } else if (currentStatut === StatutTransaction.CLOTURER) {
            this.listTraitementTransactions.splice(
                0,
                this.listTraitementTransactions.length
            );
            this.listTraitementTransactions = [
                TraitementTransaction.REFUSER,
                TraitementTransaction.ACCEPTER,
            ];
        } else {
            Object.values(TraitementTransaction).forEach((item) => {
                this.listTraitementTransactions.push(item);
            });
        }
    }
    getAllUsers() {
        this.settingService.getAllUsers({}).subscribe(
            (response: any) => {
                const users = response['data'];
                this.listUsers = users.map((el) => {
                    const data = { ...el, fullName: el.nom + ' ' + el.prenoms };
                    return data;
                });
            },
            (error) => {
                this.toastrService.error(error.error.message);
            }
        );
    }
    public copyTransaction(data: any): void {
        this.toastrService.success('Copié dans le presse papier');
        this.clipboardApi.copyFromContent(data);
    }
    public getTitleForm(operation: OperationTransaction): string {
        const titleOp = new TitleOperation();
        titleOp.setTitleForm(operation);
        return titleOp.getTitleForm;
    }
    public getCodeRapport(value: string): string {
        const code = value?.split('-');
        if (code[1] === '102') {
            return '102';
        } else if (code[1] === '100') {
            return '100';
        } else if (code[1] === '200') {
            return '200';
        } else {
            return 'false';
        }
    }

    public showDialog(data: Object): void {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
        });
        swalWithBootstrapButtons.fire({
            icon: 'info',
            html: `<strong>Message</strong> : ${data['message']} <br><br> <strong>Action</strong> : ${data['action']}`,
            confirmButtonColor: '#F07427',
            confirmButtonText: 'ok',
        });
    }

    public truncateString(str: string, num: number = 20): string {
        if (str.length > num) {
            return str.slice(0, num) + '...';
        } else {
            return str;
        }
    }

    OnShowTraitement(data: any): void {
        this.IsLoading = true;
        const modalRef = this.modalService.open(
            TraitementShowComponent,
            ModalParams
        );
        modalRef.componentInstance.transaction = {
            ...data,
            current_date: data.current_date,
            IsLoading: this.IsLoading,
        };
        modalRef.componentInstance.resultTraitement.subscribe((res) => {
            this.listTraitemants = res;
        });
        modalRef.componentInstance.IsLoading.subscribe((res) => {
            this.IsLoading = res;
            modalRef.componentInstance.IsLoadData = !res;
        });
    }
    public disableAction(): boolean {
        return this.listTraitemants === undefined ||
            this.listTraitemants?.length === 0
            ? true
            : false;
    }
    public isFilter(): boolean {
        return !this.selectedTypeOperation &&
            !this.selectedTransaction &&
            !this.selectedStatut &&
            !this.currentUser &&
            !this.selectedTraitement &&
            !this.filterDateStart &&
            !this.filterDateStart
            ? true
            : false;
    }

    changeDateStart(e) {
        if (moment(this.filterDateStart).isValid()) {
            this.selectDateStart = moment(this.filterDateStart).format(
                'YYYY-MM-DD'
            );
        } else {
            this.selectDateStart = null;
        }
    }
    changeDateEnd(e) {
        if (moment(this.filterDateEnd).isValid()) {
            this.selectDateEnd = moment(this.filterDateEnd).format(
                'YYYY-MM-DD'
            );
        } else {
            this.selectDateEnd = null;
        }
    }
    public OnExportExcel(): void {
        const data = this.listTraitemants.map((item: any) => ({
            'Date création': item?.created_at,
            'N° Dossier': item?.transaction,
            Service: item?.operation,
            Rapport: item?.code_rapport,
            Statut: item?.statut,
            Traitement: item?.traitement,
            Demandeur: `${item.demandeur_nom} ${item.demandeur_prenoms}`,
            'Date traitement': item?.current_date,
        }));
        this.excelService.exportAsExcelFile(data, 'Liste des réclamations');
    }
}
